export const channelpilotApp = {
  id: 105,
  // Technical type name — must match the backend directory name:
  // resources/external_apps/scm_app_form_config/channelpilot/ and modules/SalesChannel/Database/data/channelpilot/.
  name: "channelpilot",
  label: "ChannelPilot",
  // The ChannelPilot API has no single call that checks the credentials: the flows first post merchant
  // id + token to <url>/authentication/login and use the returned bearer token afterwards. The backend
  // has no connection-test recipe for channelpilot (credentialsTestSupported is false), so the wizard
  // skips the gate, same as websales.
  showTestConnection: false,
  logo: process.env.BASE_URL + "media/shopLogos/channelpilot.svg",
  // ChannelPilot feeds marketplaces (OTTO), not a shop: the wizard texts say "marketplace", as for
  // tradebyte.
  isMarketplace: true,
  // "migration" = initial data import, which the ChannelPilot preset does not offer. The journal stays:
  // the flows write journal entries for product, stock and prices, and the export tab reads the CFL
  // data set the flows check products against.
  areaBlacklist: ["migration"],
  // The master has no sync batch flow, so the journal's batch re-sync would start an undefined workflow.
  // Single re-syncs use the test workflows below and stay available.
  journalBatchExportBlacklist: ["product", "stock", "prices"],
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_CHANNELPILOT_PRESET_ID,
    // ChannelPilot only receives data (products, stock, prices) — no sales orders, so the generic push
    // test workflows are all it needs.
    testWorkflows: {
      product: process.env?.VUE_APP_SCM_APP_TEST_PRODUCT_WORKFLOW_ID,
      stock: process.env?.VUE_APP_SCM_APP_TEST_STOCK_WORKFLOW_ID,
      prices: process.env?.VUE_APP_SCM_APP_TEST_PRICES_WORKFLOW_ID
    },
    CFLDataSetId:
      process.env?.VUE_APP_SCM_APP_CHANNELPILOT_REPORTING_CFL_DATASET_ID
  }
};
